import { saveAs } from "file-saver";

const escapeCell = (value) => {
  const text = value === null || value === undefined ? "" : String(value);
  return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// CSV sa ";" razdvajačem i BOM-om - Excel u sr/bs/hr lokalizaciji tek tako ispravno
// otvara zarez kao decimalni znak i ćirilicu/latinicu sa dijakriticima.
export function exportCsv(filename, headers, rows) {
  const lines = [headers, ...rows].map((row) => row.map(escapeCell).join(";"));
  const blob = new Blob([`﻿${lines.join("\r\n")}`], { type: "text/csv;charset=utf-8" });
  saveAs(blob, filename.endsWith(".csv") ? filename : `${filename}.csv`);
}
